import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { StatusBadge } from '@/components/StatusBadge';
import { toast } from 'sonner';

export default function Almacenes() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    API.get('/catalogs/warehouses').then(res => setItems(res.data)).catch(() => toast.error('Error'));
  }, []);

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold">Almacenes</h1>
        <p className="text-sm text-muted-foreground">Almacenes disponibles en el sistema</p>
      </div>
      <Card className="bg-white border"><CardContent className="p-0">
        <Table>
          <TableHeader><TableRow className="bg-muted/30">
            <TableHead>Clave</TableHead><TableHead>Nombre</TableHead><TableHead>Tipo</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {items.map(w => (
              <TableRow key={w.id} className="hover:bg-muted/40">
                <TableCell className="font-mono font-medium">{w.clave}</TableCell>
                <TableCell>{w.nombre}</TableCell>
                <TableCell><StatusBadge status={w.tipo} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
}
